"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sticker_1 = require("./sticker");
var Hitbox = /** @class */ (function () {
    function Hitbox(canvas, stickerType) {
        this.canvas = canvas;
        this.width = 75;
        this.height = 75;
        this.posX = 0;
        this.posY = 0;
        this.sticker = new sticker_1.default(this.canvas, this.posX, this.posY, stickerType);
        this.drawSticker();
    }
    Hitbox.prototype.drawSticker = function () {
        this.sticker.drawSticker(this.posX, this.posY);
    };
    Hitbox.prototype.hit = function (mouseX, mouseY) {
        var rightBound = this.posX + this.width;
        var bottomBound = this.posY + this.height;
        if (mouseX > this.posX && mouseX < rightBound && mouseY > this.posY && mouseY < bottomBound)
            return true;
    };
    return Hitbox;
}());
exports.default = Hitbox;
